import { GraphQLClient } from 'graphql-request'

const endpoint = `${process.env.PAYLOAD_URL}/api/graphql`
const client = new GraphQLClient(endpoint)

export async function callGraphQlQuery(query: string) {
  try {
    return await client.request(
      query,
      {},
      { Authorization: `users API-Key ${process.env.PAYLOAD_API_KEY}` },
    )
  } catch (error) {
    throw new Error(`GraphQl call faild: ${error}`);
  }
}

export async function getCollectionSpecificFields(collectionCall: string, fields: string, condition = '', limit = 10000, draft = false) {
  const query = `
  query {
    ${collectionCall}(
      draft: ${draft}
      limit: ${limit}
      page: 1
      where: {${condition}}
    ) {
      docs {
        ${fields}
      }
      totalDocs
    }
  }
`
  return await callGraphQlQuery(query)
}

export async function getCollectionSpecificFieldsByVersion(collectionCall: string, fields: string, versionId = '', limit = 1000) {
  const query = `
  query {
    ${collectionCall}(
      limit: ${limit}
      page: 1
      where: {id: { equals: "${versionId}"}}
    ) {
      docs {
        id
        version {
          ${fields}
        }
      }
      totalDocs
    }
  }
`
  return await callGraphQlQuery(query)
}

export async function requestToAPI(urlToFetch: string) {
  let url, response
  if (process.env.PAYLOAD_URL) {
    url = `${process.env.PAYLOAD_URL}/api/${urlToFetch}`
    response = await fetch(url, {
      headers: {
        Authorization: `users API-Key ${process.env.PAYLOAD_API_KEY}`,
      },
    }) //TODO add Error handling as callback in fetch APIs

  } else {
    url = `/api/${urlToFetch}`
    response = await fetch(url, {})
  }
  const jsonData = response ? await response.json() : ''
  return jsonData
}

//Get a collection doc
export interface IPropsOneCollectionDoc {
  collectionName: string
  idOrSlug: string
  getBy: 'id' | 'slug'
  depth?: number
  isDraft?: boolean
}
export async function getCollectionDoc({
  collectionName,
  idOrSlug,
  getBy,
  depth = 1,
  isDraft = false,
}: IPropsOneCollectionDoc) {
  async function loadViaGet() {
    const urlToFetch = `${collectionName}?where[${getBy}][equals]=${idOrSlug}&depth=${depth}&draft=${isDraft}`
    const jsonData = await requestToAPI(urlToFetch)
    return jsonData?.docs?.length == 1 ? jsonData.docs[0] : null
  }
  return await loadViaGet()
}

//Get a global doc
interface IPropsGlobalDoc {
  globalName: string
  depth?: number
  isDraft?: boolean
}
export async function getGlobalDoc({ globalName, depth = 1, isDraft = false }: IPropsGlobalDoc) {
  async function loadViaGet() {
    const urlToFetch = `globals/${globalName}?depth=${depth}&draft=${isDraft}`
    return await requestToAPI(urlToFetch)
  }
  return await loadViaGet()
}

//Get all docs fom a collection
interface IPropsAllDocs {
  collectionName: string
  limit?: number
}
export async function getAllDocsFromCollection({ collectionName, limit = -1 }: IPropsAllDocs) {
  async function loadViaGet() {
    const ifLimit = limit === -1 ? '' : `limit=${limit}&`
    const justPublished = `where${collectionName === 'legacyprofiles' ? '[published][equals]=true' : '[_status][equals]=published'} `
    const urlToFetch = `${collectionName}?${ifLimit}${justPublished}`
    return await requestToAPI(urlToFetch)
  }

  return await loadViaGet()
}